type FullscreenEscapeEntry = {
    exit: () => void;
};

/**
 * This stack is used to track the fullscreen window for escaping
 * the fullscreen mode via escape key top-down.
 */
const exitStack: FullscreenEscapeEntry[] = [];
let globalListenerAttached = false;

// exit the topmost fullscreen window when the escape key is pressed.
function handleGlobalEscape(event: KeyboardEvent) {
    if (event.key !== 'Escape' || exitStack.length === 0) {
        return;
    }

    const top = exitStack[exitStack.length - 1];
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    top.exit();
}

// Ensure the global escape listener is attached only once.
function ensureGlobalListener() {
    if (globalListenerAttached) {
        return;
    }
    globalListenerAttached = true;
    document.addEventListener('keydown', handleGlobalEscape, true);
}

// Register a new fullscreen escape entry.
// Returns a function to unregister the entry.
export function registerFullscreenEscape(exit: () => void): () => void {
    ensureGlobalListener();
    const entry: FullscreenEscapeEntry = { exit };
    exitStack.push(entry);
    return () => {
        const index = exitStack.lastIndexOf(entry);
        if (index !== -1) {
            exitStack.splice(index, 1);
        }
    };
}
